import { store } from "@/services";

/**
 * Modulo control de layout aplicacion
 */

const state = {
  drawer: true,
  orders: [],
  pending_shipping: [],
  pagination_pending_shipping: {},
  technical_services: [],
  pagination: {},
};

const getters = {
  /**
   * [DRAWER_STATE description]
   * @param {[type]} state [description]
   * @return {boolean}
   */
  DRAWER_STATE(state) {
    return state.drawer;
  },
  ORDERS(state) {
    return state.orders;
  },
  PENDING_SHIPPING(state) {
    return state.pending_shipping;
  },
  PAGINATION(state) {
    return state.pagination;
  },
  PAGINATION_PENDING_SHIPPING(state) {
    return state.pagination_pending_shipping;
  },
  TECHNICAL_SERVICES(state) {
    return state.technical_services;
  },
};

const mutations = {
  /**
   * [SET_DRAWER description]
   * @param {[type]} state   [description]
   * @param {boolean} payload [description]
   */
  SET_DRAWER(state, payload) {
    state.drawer = payload;
  },

  SET_ITEM_ORDERS(state, payload) {
    state.orders = { data: payload.data, pagination: payload.pagination };
  },

  SET_PENDING_SHIPPING(state, payload) {
    console.log("payload", payload);
    state.pending_shipping = payload;
    state.pagination_pending_shipping = {
      lastPage: payload.pagination.lastPage,
      page: payload.pagination.page,
      perPage: payload.pagination.perPage,
      total: payload.pagination.total,
    };
  },

  SET_TECHNICAL_SERVICES(state, payload) {
    state.technical_services = payload;
  },
  SET_MY_ORDERS(state, payload) {
    // elimino del array de pendientes por facturar
    state.orders.data.splice(payload.position, 1);
    // agrego en el array de pedidos facturados
    state.pending_shipping.push(payload.data?.order_item);
  },
  DELETE_ORDERS(state, payload) {
    state.orders.splice(payload.position, 1);
  },
};

const actions = {
  async MY_ORDERS({ commit }, payload) {
    try {
      const response = await store.get(
        `api/b2b/shopping-carts?page=${payload.page}&per_page=${payload.per_page}&paginate=${payload.paginate}`,
        payload
      );
      const data = {
        data: response.data.data.data,
        pagination: {
          lastPage: response.data.data.lastPage,
          page: response.data.data.page,
          perPage: response.data.data.perPage,
          total: response.data.data.total,
        },
      };
      commit("SET_ITEM_ORDERS", data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async PENDING_SHIPPING({ commit }, payload) {
    try {
      const response = await store.get(
        `api/b2b/transactions?page=${payload.page}&per_page=${payload.per_page}&paginate=${payload.paginate}`,
        payload
      );
      const data = {
        data: response.data.data.data,
        pagination: {
          lastPage: response.data.data.lastPage,
          page: response.data.data.page,
          perPage: response.data.data.perPage,
          total: response.data.data.total,
        },
      };
      commit("SET_PENDING_SHIPPING", data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async PENDING_SHIPPING_PAGINATION({ commit }, payload) {
    try {
      const response = await store.get(`${payload.url}`);
      commit("SET_PENDING_SHIPPING", response.data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async TECHNICAL_SERVICES({ commit }, payload) {
    try {
      const response = await store.get("/tickets_b2b", payload);
      commit("SET_TECHNICAL_SERVICES", response.data.data);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async VERIFY_SHOOPING_CART({ dispatch }, payload) {
    try {
      const response = await store.post(`api/b2b/invoice_order`, payload);
      const data = {
        position: payload.position,
        data: response.data.data,
      };
      console.log("data", data);
      // commit("SET_MY_ORDERS", data);

      await dispatch("MY_ORDERS", {
        page: 1,
        per_page: 5,
        paginate: true,
      });

      await dispatch("PENDING_SHIPPING", {
        page: 1,
        per_page: 5,
        paginate: true,
      });
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async CHECK_IN_PDF(_, payload) {
    try {
      const response = await store.get(`/sales/get-invoice/${payload.id}`);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async CHECK_IN_EMAIL(_, payload) {
    try {
      const response = await store.get(`/sales/send-invoice/${payload.id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async SHOPPING_CART_EMAIL(_, payload) {
    try {
      const response = await store.get(`api/b2b/send_mail/${payload.id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async CHECK_IN_DELETE(_, payload) {
    try {
      const response = await store.get(`/sales/delete/${payload.id}`);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async ORDER_DELETE({ commit }, payload) {
    try {
      const response = await store.put(`api/b2b/cancelled/${payload.id}`);
      const data = {
        position: payload.position,
      };
      commit("DELETE_ORDERS", data);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export const layout = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
